(function() {
    let selectors = {
            email_pattern: /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/,
            name_pattern: /^[A-Za-z\s\-]+$/,
            phone_pattern: /^[0-9]+$/,
            zip_pattern: /^[0-9-a-z-A-Z]+$/,
            handle: location.href.split("/")[4].split("?")[0]
        },
        initialiseSelectors = (selectors2, handle) => {
            switch (handle) {
                case "login": {
                    ['[action="/account/login"]', '[action="/account/recover"]'].forEach((formSelector, index) => {
                        let form = document.querySelector(formSelector),
                            submitBtn = form.querySelector("button"),
                            inputFields = index == 0 ? form.querySelectorAll("[name*=customer]") : form.querySelector('[name="email"]');
                        createErrorContainer(form, index), index == 0 ? addEventsToMultipleFields(form, submitBtn, inputFields, selectors2, "customer") : addEventsToSingleField(form, submitBtn, inputFields, selectors2)
                    });
                    break
                }
                case "register": {
                    let form = document.querySelector('[action="/account"]'),
                        submitBtn = form.querySelector("button"),
                        inputFields = form.querySelectorAll("[name*=customer]");
                    createErrorContainer(form, 0), addEventsToMultipleFields(form, submitBtn, inputFields, selectors2, "customer");
                    break
                }
                case "addresses": {
                    document.querySelectorAll('[action*="/account/addresses"]').forEach(form => {
                        let submitBtn = form.querySelector("button"),
                            inputFields = form.querySelectorAll("[name*=address]");
                        createErrorContainer(form, 0), addEventsToMultipleFields(form, submitBtn, inputFields, selectors2, "address")
                    });
                    break
                }
                case "contact-us__1": {
                    let form = document.querySelector('.main--contact_form[action*="/contact"]');
                    console.log(form);
                    let submitBtn = form.querySelector("button"),
                        inputFields = form.querySelectorAll("[name*=contact]");
                    createErrorContainer(form, 0), addEventsToMultipleFields(form, submitBtn, inputFields, selectors2, "contact");
                    break
                }
                case "contact-sawsalvage": {
                    let form = document.querySelector('.contact-form[action*="/contact"]'),
                        submitBtn = form.querySelector("button"),
                        inputFields = form.querySelectorAll("[name*=contact]");
                    createErrorContainer(form, 0), addEventsToMultipleFields(form, submitBtn, inputFields, selectors2, "contact");
                    break
                }
                case "login#recover": {
                    initialiseSelectors(selectors2, "login");
                    break
                }
                case "contact": {
                    initialiseSelectors(selectors2, "contact-us__1");
                    break
                }
                case "contact-us__1": {
                    initialiseSelectors(selectors2, "contact-us__1");
                    break
                }
                case "reset": {
                    let form = document.querySelector('[action*="/account/reset"]'),
                        submitBtn = form.querySelector("button"),
                        inputFields = form.querySelectorAll("[name*=customer]");
                    createErrorContainer(form, 0), addEventsToMultipleFields(form, submitBtn, inputFields, selectors2, "customer");
                    break
                }
            }
        },
        createErrorContainer = (form, index) => {
            let errorHtml = '<span class="error-svg-container"> <svg focusable="false" width="18" height="26" class="icon icon--form-error" viewBox="0 0 18 26"> <circle cx="9" cy="13" r="8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></circle> <path d="M8.993 15.262a.972.972 0 00-.979.968c0 .539.44.99.98.99a.99.99 0 00.978-.99.972.972 0 00-.979-.968zm-.78-.649h1.561V8.706H8.212v5.907z" fill="currentColor"></path> </svg> </span> <span class="form--error">**Email required</span>',
                styleHtml = "<style>.form--error-container{color:red;text-align:center;font-size:16px;margin-bottom:24px;background:#fdf0f0;padding:13px 18px;display:flex;justify-content:flex-start}.error-svg-container{margin-right:10px}.hide{display:none!important}[type=submit]:disabled{cursor:not-allowed!important}</style>";
            index == 0 ? document.head.innerHTML += styleHtml : document.head.innerHTML += "";
            const newNode = document.createElement("div");
            newNode.classList.add("form--error-container", "hide"), form.insertBefore(newNode, form.querySelectorAll("input")[0]), form.querySelector(".form--error-container").innerHTML = errorHtml
        },
        addEventsToMultipleFields = (form, button, inputFields, selectors2, formType) => {
            disableSubmitBtn(button, !0), inputFields.forEach(field => {
                let fieldType = field.getAttribute("name").split(formType + "[")[1].split("]")[0];
                ["last_name", "first_name", "email", "name", "country", "city", "phone", "address1", "zip", "password"].includes(fieldType) ? ["last_name", "country"].includes(fieldType) ? field.setAttribute("data-status", "true") : field.setAttribute("data-status", "false") : field.setAttribute("no-status", ""), ["input", "change"].forEach(evt => {
                    field.addEventListener(evt, e => {
                        validateDetails(form, button, e.currentTarget, selectors2, fieldType)
                    })
                })
            })
        },
        addEventsToSingleField = (form, button, inputField, selectors2) => {
            disableSubmitBtn(button, !0), ["input", "blur", "change"].forEach(evt => {
                inputField.addEventListener(evt, e => {
                    e.currentTarget.value = e.currentTarget.value.trim(), validateDetails(form, button, e.currentTarget, selectors2, "email")
                })
            })
        },
        disableSubmitBtn = (button, status) => {
            status ? button.setAttribute("disabled", "") : button.removeAttribute("disabled")
        },
        validateDetails = (form, button, field, selectors2, type) => {
            let isBlank = field.value == "",
                errorSpan = form.querySelector(".form--error-container .form--error");
            switch (type) {
                case "email": {
                    let isInvalidString = !!(!field.value.match(selectors2.email_pattern) || field.value.match(selectors2.phone_pattern));
                    manageError(isBlank ? "Email required" : isInvalidString ? "Invalid Email." : "", errorSpan, field, button, form);
                    break
                }
                case "password": {
                    let isShortString = field.value.length < 8,
                        isResetPasswordError = selectors2.handle == "reset" && form.querySelector('[name="customer[password_confirmation]"]').value.length > 7;
                    isBlank ? manageError("Password required", errorSpan, field, button, form) : isShortString ? manageError("Min. 8 characters required", errorSpan, field, button, form) : (manageError("", errorSpan, field, button, form), isResetPasswordError ? validateDetails(form, button, form.querySelector('[name="customer[password_confirmation]"]'), selectors2, "password_confirmation") : console.log());
                    break
                }
                case "first_name": {
                    let isInvalidString = !field.value.match(selectors2.name_pattern),
                        isShortString = field.value.length < 3;
                    manageError(isBlank ? "Name required" : isInvalidString ? "Invalid name" : isShortString ? "Min. 3 characters required" : "", errorSpan, field, button, form);
                    break
                }
                case "last_name": {
                    let isInvalidString = !field.value.match(selectors2.name_pattern);
                    manageError(isBlank ? "" : isInvalidString ? "Invalid Last name" : "", errorSpan, field, button, form);
                    break
                }
                case "phone": {
                    let isInvalidString = !field.value.match(selectors2.phone_pattern),
                        isInvalidlength = field.value.length < 8 || field.value.length > 15;
                    manageError(isBlank ? "Phone required" : isInvalidString ? "Invalid Phone Number" : isInvalidlength ? "Digit count should be between 8-15" : "", errorSpan, field, button, form);
                    break
                }
                case "address1": {
                    let isShortString = field.value.length < 3;
                    manageError(isBlank ? "Address required" : isShortString ? "Min. 3 characters required" : "", errorSpan, field, button, form);
                    break
                }
                case "city": {
                    let isInvalidString = !field.value.match(selectors2.name_pattern),
                        isShortString = field.value.length < 3;
                    manageError(isBlank ? "City required" : isInvalidString ? "Invalid City" : isShortString ? "Min. 3 characters required" : "", errorSpan, field, button, form);
                    break
                }
                case "zip": {
                    let isInvalidString = !field.value.match(selectors2.zip_pattern),
                        isShortString = field.value.length < 3;
                    manageError(isBlank ? "Zip Code required" : isInvalidString ? "Invalid Zip Code" : isShortString ? "Min. 3 characters required" : "", errorSpan, field, button, form);
                    break
                }
                case "country": {
                    let isInvalidString = !!field.value.includes("-");
                    manageError(isInvalidString ? "Select Country" : "", errorSpan, field, button, form);
                    break
                }
                case "name": {
                    validateDetails(form, button, field, selectors2, "first_name");
                    break
                }
                case "password_confirmation": {
                    let isShortString = field.value.length < 8,
                        isNotSame = form.querySelector('[name="customer[password]"]').value != field.value;
                    manageError(isBlank ? "Confirm password required" : isShortString ? "Min. 8 characters required" : isNotSame ? "Both passwords should be same" : "", errorSpan, field, button, form);
                    break
                }
            }
        },
        manageError = (message, errorSpan, field, button, form) => {
            message.trim() != "" ? (errorSpan.innerHTML = message, field.setAttribute("data-status", "false"), errorSpan.parentElement.classList.remove("hide"), disableSubmitBtn(button, !0)) : (errorSpan.innerHTML = "", field.setAttribute("data-status", "true"), errorSpan.parentElement.classList.add("hide"), checkStatus(form, button))
        },
        checkStatus = (form, button) => {
            let inputFields = form.querySelectorAll("[data-status]"),
                trueStatus = 0;
            inputFields.forEach(field => {
                field.getAttribute("data-status") == "true" ? trueStatus += 1 : trueStatus += 0
            }), trueStatus == inputFields.length ? disableSubmitBtn(button, !1) : disableSubmitBtn(button, !0)
        };
    initialiseSelectors(selectors, selectors.handle)
})();





$(document).ready(function () {
    var nameErr = '',
      emailErr = '',
      phoneErr = '';
    // let error_svg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">' +
    //   '<circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>' +
    //   '<circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>' +
    //   '<path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>' +
    //   '<path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">' +
    //   '</path></svg>';
     let error_svg='';
    $("#full_name").keyup(function () {
      $("#full_name").attr("onsubmit", '');
      let name = $(this).val();
      nameErr = checkname(name);
    });
    $("#email").keyup(function () {
      $("#ContactForm").attr("onsubmit", '');
      let email = $(this).val();
      emailErr = checkEmail(email);
    });
    $("#phone").keyup(function () {
      $("#ContactForm").attr("onsubmit", '');
      let phone = $(this).val();
      phoneErr = checkphone(phone);
    });
    $(".contact-button").click(function (e) {
      $("#ContactForm").attr("onsubmit", '');
      e.preventDefault();
      let error = false;

      var name = $("#full_name").val(),
        email = $("#email").val();
      phone = $("#phone").val();
      nameErr = checkname(name);
      emailErr = checkEmail(email);
      phoneErr = checkphone(phone);

      if (nameErr === true && emailErr === true && phoneErr === true) {
        $("#ContactForm").submit();
      }else{

        $('html, body').animate({
            scrollTop: $("#ContactForm").offset().top
        }, 800);
      }
    });


    function checkname(name) {
      if (name === "") {
        $("#full_name-error").removeClass("custom-hide").addClass("custom-show");
        $("#full_name-error span:nth-last-child(1)").html(error_svg + "This field is required.");
        return false;
      }
      else if (!name.match(/^[A-Za-z\s\-]+$/)) {
        $("#full_name-error").removeClass("custom-hide").addClass("custom-show");
        $("#full_name-error span:nth-last-child(1)").html(error_svg + "Only letters, white space and dash allowed.");
        return false;
      } else if (name.length < 3) {
        $("#full_name-error").removeClass("custom-hide").addClass("custom-show");
        $("#full_name-error span:nth-last-child(1)").html(error_svg + "Length should be greater than 2.");
        return false;
      } else {
        $("#full_name-error").removeClass("custom-show").addClass("custom-hide");
        $("#full_name-error span:nth-last-child(1)").html("");
        return true;
      }
    }

    function checkEmail(email) {
      if (email === "") {
        $("#email-error").removeClass("custom-hide").addClass("custom-show");
        $("#email-error span:nth-last-child(1)").html(error_svg + "This field is required.");
        return false;
      } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
        $("#email-error").removeClass("custom-hide").addClass("custom-show");
        $("#email-error span:nth-last-child(1)").html(error_svg + "Please Enter valid email.");
        $error = false;
      } else {
        $("#email-error").removeClass("custom-show").addClass("custom-hide");
        $("#email-error span:nth-last-child(1)").html("");
        return true;
      }
    }
    function checkphone(phone) {
      let phoneEx = new RegExp("^\d{10}$", "g");
      if (phone === "") {
        $("#phone-error").removeClass("custom-hide").addClass("custom-show");
        $("#phone-error span:nth-last-child(1)").html(error_svg + "This field is required.");
        return false;
      } else if (phone.match(/[^0-9]/g)) {
        $("#phone-error").removeClass("custom-hide").addClass("custom-show");
        $("#phone-error span:nth-last-child(1)").html(error_svg + "Only number allowed.");
        return false;
      }
      else if (phone.length != 10) {
        $("#phone-error").removeClass("custom-hide").addClass("custom-show");
        $("#phone-error span:nth-last-child(1)").html(error_svg + "Phone number length should be 10.");
        return false;
      } else {
        $("#phone-error").removeClass("custom-show").addClass("custom-hide");
        $("#phone-error span:nth-last-child(1)").html("");
        return true;
      }
    }

    function checkCompany(company, id = '') {
      if (company !== '' && !company.match(/^[A-Za-z0-9\s\-]+$/)) {
        $("#ContactForm-company-name-error").removeClass("custom-hide").addClass("custom-show");
        $("#ContactForm-company-name-error span:nth-last-child(1)").html(error_svg + "Only letters, white space, numbers and dash allowed.");
        return false;
      } else if (company != '' && company.length < 3) {
        $("#ContactForm-company-name-error").removeClass("custom-hide").addClass("custom-show");
        $("#ContactForm-company-name-error span:nth-last-child(1)").html(error_svg + "Length should be greater than 2.");
        return false;
      } else {
        $("#ContactForm-company-name-error").removeClass("custom-show").addClass("custom-hide");
        $("#ContactForm-company-name-error span:nth-last-child(1)").html("");
        return true;
      }
    }
    function ckeckAddress(address, id = '') {
      if (address !== '' && !address.match(/^[A-Za-z0-9\s\-]+$/)) {
        $("#ContactForm-address-error").removeClass("custom-hide").addClass("custom-show");
        $("#ContactForm-address-error span:nth-last-child(1)").html("Only letters, white space, numbers and dash allowed.");
        return false;
      } else if (address !== '' && address.length < 3) {
        $("#ContactForm-address-error").removeClass("custom-hide").addClass("custom-show");
        $("#ContactForm-address-error span:nth-last-child(1)").html("Length should be greater than 2.");
        return false;
      } else {
        $("#ContactForm-address-error").removeClass("custom-show").addClass("custom-hide");
        $("#ContactForm-address-error span:nth-last-child(1)").html("");
        return true;
      }
    }
  });
